export enum EMerchantPixelsAndKeys {
  FACEBOOK_PIXEL = 'facebookPixelId',
  GOOGLE_TAG_MANAGER = 'googleTagManager',
  GOOGLE_ADWORDS_KEY = 'googleAdWordsKey',
  GOOGLE_ADWORDS_CONVERSION_LABEL = 'googleAdWordsConversionLabel',
}
